import { useEffect } from 'react';
import { supabase } from '../integrations/supabase/client';

export const useAutoSubscribePush = () => {
  useEffect(() => {
    const autoSubscribe = async () => {
      try {
        // Verificar se o usuário está autenticado
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) return;

        // Verificar se o browser suporta push notifications
        if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
          console.log('Push notifications não suportadas neste browser');
          return;
        }

        // Verificar se já tem permissão
        if (Notification.permission === 'granted') {
          await subscribeToPush();
        } else if (Notification.permission === 'default') {
          // Solicitar permissão automaticamente
          const permission = await Notification.requestPermission();
          if (permission === 'granted') {
            await subscribeToPush();
          }
        }
      } catch (error) {
        console.error('Erro ao configurar push notifications:', error);
      }
    };

    const subscribeToPush = async () => {
      try {
        // Buscar VAPID key
        const { data: vapidResponse, error: vapidError } = await supabase.functions.invoke('get-vapid-keys');
        if (vapidError) throw vapidError;

        const vapidPublicKey = vapidResponse.publicKey;
        if (!vapidPublicKey) throw new Error('VAPID public key não encontrada');

        // Registrar service worker
        const registration = await navigator.serviceWorker.register('/sw.js');
        await navigator.serviceWorker.ready;

        // Criar subscription
        const subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(vapidPublicKey)
        });

        // Salvar no banco
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) return;

        await supabase
          .from('push_subscriptions')
          .upsert({
            user_id: user.id,
            endpoint: subscription.endpoint,
            p256dh: subscription.getKey('p256dh') ? btoa(String.fromCharCode(...new Uint8Array(subscription.getKey('p256dh')!))) : null,
            auth: subscription.getKey('auth') ? btoa(String.fromCharCode(...new Uint8Array(subscription.getKey('auth')!))) : null,
            subscription_data: subscription.toJSON() as any
          });

        console.log('✅ Push notifications ativadas automaticamente');
      } catch (error) {
        console.error('Erro ao ativar push notifications:', error);
      }
    };

    const urlBase64ToUint8Array = (base64String: string) => {
      const padding = '='.repeat((4 - base64String.length % 4) % 4);
      const base64 = (base64String + padding)
        .replace(/-/g, '+')
        .replace(/_/g, '/');

      const rawData = window.atob(base64);
      const outputArray = new Uint8Array(rawData.length);

      for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
      }
      return outputArray;
    };

    autoSubscribe();
  }, []);
};